import { THEME_LABELS, setTheme } from './theme.js';
import { useTheme } from './useTheme.js';

/**
 * The theme switch both app headers mount. Pair a sun or moon SVG with the
 * visible word Light or Dark naming the theme you would GET: no mystery glyphs.
 * Chris's feedback (2026-09-10): omit the Canvas and Obsidian theme names.
 */
export function ThemeToggle() {
  const theme = useTheme();
  const next = theme === 'obsidian' ? 'canvas' : 'obsidian';
  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={() => setTheme(next)}
      aria-label={`Switch to ${next === 'canvas' ? 'light' : 'dark'} theme`}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        {next === 'canvas' ? (
          <>
            <circle cx="12" cy="12" r="4" />
            <path d="M12 2v2m0 16v2M2 12h2m16 0h2M4.93 4.93l1.42 1.42m11.3 11.3 1.42 1.42M4.93 19.07l1.42-1.42m11.3-11.3 1.42-1.42" />
          </>
        ) : (
          <path d="M20.9 13A9 9 0 0 1 11 3.1 9 9 0 1 0 20.9 13Z" />
        )}
      </svg>{' '}
      {THEME_LABELS[next]}
    </button>
  );
}
